import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../model/rootReducer'
import ActionsForm from './actionsForm/ActionsForm'
import PathGenerationForm from './generationForms/PathGenerationForm'

type FormProps = {
  generatePath: (selectedFilters: Object) => void
  updatePath: () => void
  setConversationId: (conversationId: string) => void
  selectedActions: string[]
}

const PathForms: React.FunctionComponent<FormProps> = ({
  generatePath,
  updatePath,
  setConversationId,
  selectedActions,
}) => {
  const pathData = useSelector((state: RootState) => state.monitoringGraph.path)

  return (
    <div>
      <PathGenerationForm
        generatePath={generatePath}
        setConversationId={setConversationId}
      />
      {pathData.availableActions.length > 0 && (
        <ActionsForm
          updateGraph={updatePath}
          actions={pathData}
          selectedActions={selectedActions}
        ></ActionsForm>
      )}
    </div>
  )
}
export default PathForms
